import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Clock, CheckCircle } from "lucide-react";

/**
 * CallHistory - Recent calls sidebar component
 */
export default function CallHistory({ calls = [] }) {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Clock className="w-4 h-4" />
          Recent Calls
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-48">
          {calls.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">
              No recent calls
            </p>
          ) : (
            <div className="space-y-3">
              {calls.slice(0, 5).map((call, idx) => (
                <div key={idx} className="flex items-center gap-3 text-sm">
                  <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="font-medium truncate">{call.patient_name}</p>
                    <p className="text-xs text-muted-foreground">
                      {formatDate(call.created_at)} • {formatDuration(call.duration_seconds || 0)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
